import {
    filterOutEmptySelectedAmenities
} from "@CheckOrder/features/amenities/functions/filterOutEmptySelectedAmenities";
import {
    PairedSingleAndReturnAmenitiesType
} from "@CheckOrder/features/amenities/types/PairedSingleAndReturnAmenities.type";
import {useAppSelector} from "@Hooks/selector/useAppSelector";
import {GeneralAmenitySelectedType} from "@CheckOrder/features/amenities/types/GeneralAmenitySelected.type";
import entries from "@Object/entries";
import useUpdateAmenitiesQuery from "@CheckOrder/features/amenities/hooks/useUpdateAmenitiesQuery";

export default function useRemoveSelectedAmenities(pairedAmenityGroups: PairedSingleAndReturnAmenitiesType) {
    const {
        singleSelectedAmenities,
        returnSelectedAmenities,
    } = useAppSelector((state) => (state?.checkOrder?.ticket))

    const {updateAmenities, response} = useUpdateAmenitiesQuery()

    const removeSelectedAmenities = (selectedAmenities: Record<string, GeneralAmenitySelectedType>) => (
        Object.fromEntries(entries(selectedAmenities ?? {}).filter(([_key, amenity]) => {
            if (amenity.type === "count") {
                return !pairedAmenityGroups.amenityKeys.includes(amenity.key)
            }
        }))
    )

    const removeAmenityGroup = async () => {
        await updateAmenities(
            removeSelectedAmenities(filterOutEmptySelectedAmenities(singleSelectedAmenities)),
            removeSelectedAmenities(filterOutEmptySelectedAmenities(returnSelectedAmenities))
        )
    }

    return {
        removeAmenityGroup,
        response,
    }
}